import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "title"
}
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "search" }
const _hoisted_4 = { class: "icon" }
const _hoisted_5 = { class: "actions" }
const _hoisted_6 = { class: "reports" }
const _hoisted_7 = {
  key: 0,
  class: "empty"
}

import { computed, onMounted, ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import { useI18n } from "vue-i18n";
import store from "@/store";

import type { ReportType, ReportPayloadType } from "@/common/types/report";

import { toast } from "@/common/utils/toast";
import {
  reportList,
  reportCreate,
  reportDelete,
} from "@/common/api/rest/report/report";

import {
  baseConfirm,
  baseInput,
  baseModal,
  cardReport,
  svgIcon,
} from "@/common/components";

import { reportForm } from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'report',
  props: {
    evaluationId: {},
    width: { default: "100%" },
    showTitle: { type: Boolean, default: true },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();
const route = useRoute();
const router = useRouter();

const emit = __emit;

const props = __props;

const DEFAULT_PAYLOAD = {
  name: "",
  description: null,
};

const searchInput = ref("");
const reports = ref<ReportType[]>([]);
const selected = ref<ReportType | null>(null);
const payload = ref<ReportPayloadType>({ ...DEFAULT_PAYLOAD });

const showModalAdd = ref(false);
const showConfirmDel = ref(false);

const accountId = computed(() => route.params.id as string);

function fetchData() {
  reportList(accountId.value, {
    evaluation_id: props.evaluationId,
    full: true,
    search: searchInput.value,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        reports.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function update() {
  emit("update-data");
}

function add() {
  payload.value = { ...DEFAULT_PAYLOAD };
  showModalAdd.value = true;
}

function addCancel() {
  showModalAdd.value = false;
  payload.value = { ...DEFAULT_PAYLOAD };
}

function addConfirm() {
  showModalAdd.value = false;

  reportCreate(accountId.value, {
    evaluation_id: props.evaluationId,
    name: payload.value.name,
    description: payload.value.description,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        fetchData();
        update();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function remove(data: ReportType) {
  selected.value = data;
  showConfirmDel.value = true;
}

function removeCancel() {
  selected.value = null;
  showConfirmDel.value = false;
}

function removeConfirm() {
  if (!selected.value) return;

  store.commit("SET_LOADING", true);

  reportDelete(accountId.value, selected.value.report_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        fetchData();
        removeCancel();
        update();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    })
    .finally(() => {
      store.commit("SET_LOADING", false);
    });
}

function selectReport(data: ReportType) {
  router.push(`/${accountId.value}/report/${data.report_id}`);
}

function copyReport(data: ReportType) {
  console.log("copy-report", data);
}

function cleanSearch() {
  if (!searchInput.value) {
    fetchData();
  }
}

function searchValue() {
  fetchData();
}

onMounted(() => {
  fetchData();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["tab-component", { width: __props.width }])
  }, [
    (__props.showTitle)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(t)("common.labels.reports")), 1))
      : _createCommentVNode("", true),
    _createElementVNode("section", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(baseInput), {
          modelValue: searchInput.value,
          "onUpdate:modelValue": [
            _cache[1] || (_cache[1] = ($event: any) => ((searchInput).value = $event)),
            _cache[2] || (_cache[2] = ($event: any) => (cleanSearch()))
          ],
          background: "#fff",
          color: "#000",
          placeholder: _unref(t)('common.labels.search'),
          "onKey:enter": _cache[3] || (_cache[3] = ($event: any) => (searchValue()))
        }, {
          sufix: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_unref(svgIcon), {
                icon: "search",
                size: "1.75rem",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (searchValue()))
              })
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "btn btn-md btn-primary",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (add()))
        }, [
          _createVNode(_unref(svgIcon), {
            icon: "add",
            size: "1.1rem"
          }),
          _createElementVNode("span", null, _toDisplayString(_unref(t)("common.labels.report")?.toUpperCase()), 1)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(reports.value, (item) => {
        return (_openBlock(), _createBlock(_unref(cardReport), {
          key: item.report_id,
          data: item,
          onCopy: ($event: any) => (copyReport(item)),
          onEdit: ($event: any) => (selectReport(item)),
          onDelete: ($event: any) => (remove(item))
        }, null, 8, ["data", "onCopy", "onEdit", "onDelete"]))
      }), 128)),
      (reports.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(t)("evaluation.texts.empty_evaluation")), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(baseConfirm), {
      show: showConfirmDel.value,
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.report'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: selected.value?.name,
        })
      ,
      onCancel: removeCancel,
      onConfirm: removeConfirm
    }, null, 8, ["show", "title", "message"]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.confirm'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[6] || (_cache[6] = ($event: any) => (addCancel())),
      onConfirm: _cache[7] || (_cache[7] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(reportForm), {
          title: _unref(t)('common.labels.add', { concat: _unref(t)('common.labels.report') }),
          data: payload.value,
          onUpdateData: _cache[5] || (_cache[5] = ($event: any) => (payload.value = $event))
        }, null, 8, ["title", "data"])
      ]),
      _: 1
    }, 8, ["show", "button-confirm", "button-close"])
  ], 2))
}
}

})